// Angular
import { Component, Input } from '@angular/core';
import { NotificationService } from '../../../../../provider/notification.service';
import { NotificationModel } from '../../../../models/notification.model';
import { RequestsService } from '../../../../../provider/requests.service';
import { Router } from '@angular/router';

@Component({
  selector: 'kt-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['notification.component.scss']
})
export class NotificationComponent {

  // Show dot on top of the icon
  @Input() dot: string;

  // Show pulse on icon
  @Input() pulse: boolean;

  @Input() pulseLight: boolean;

  // Set icon class name
  @Input() icon = 'flaticon2-bell-alarm-symbol';
  @Input() iconType: '' | 'success';

  // Set true to icon as SVG or false as icon class
  @Input() useSVG: boolean;

  // Set bg image path
  @Input() bgImage: string;

  // Set skin color, default to light
  @Input() skin: 'light' | 'dark' = 'light';

  @Input() type: 'brand' | 'success' = 'success';

  constructor(public myService: NotificationService,
    public requestService: RequestsService,
    private router: Router) {
    this.myService.getNotifications();
    this.requestService.getRequest();
  }

  backGroundStyle(): string {
    if (!this.bgImage) {
      return 'none';
    }

    return 'url(' + this.bgImage + ')';
  }

  getNotificationCount(datas: NotificationModel[]): number {
    const new_nottifications = datas.filter(x => x.status == 0);
    return new_nottifications.length;
  }

  gotoRequest() {
    this.router.navigateByUrl('/home/requests');
  }
}
